module.exports = "/images/avatar-s-7.jpg?b00fd0f744875b2f52e7cdcb863246e9";